export const ADD_CONFIG = 'ADD_CONFIG';
export const UPDATE_CONFIG = 'UPDATE_CONFIG';
export const DELETE_CONFIG = 'DELETE_CONFIG';

export const addConfigData = (data) => ({
    type: ADD_CONFIG,
    data: data
});

export const updateConfigData = (data) => ({
    type: UPDATE_CONFIG,
    data: data
});

export const deleteConfigData = () => ({
    type: DELETE_CONFIG
});
